<script>
export default {
    name: "ViewPaymentDetails",

    props: {
        consultant: String,
        payment: Object,
        paymentDetails: Array,
        showModal: Boolean,
    },

    computed: {

        totalPaid() {
            if(!this.paymentDetails.length) return 0;

            return this.paymentDetails.map(paymentD => parseFloat(paymentD.paid))
                .reduce((sum, amount) => sum + amount);
        },

        totalAmount() {
            if(!this.paymentDetails.length) return 0;

            return this.paymentDetails.map(paymentD => parseFloat(paymentD.amount))
                .reduce((sum, amount) => sum + amount);
        },

        totalBalance() {
            if(!this.paymentDetails.length) return 0;

            return this.paymentDetails.map(paymentD => parseFloat(paymentD.balance))
                .reduce((sum, amount) => sum + amount);
        },
    },

    methods: {

        printDetails() {

            window.open(
                `/billing/consultant-dashboard/payment/print?InvoiceRef=${this.payment.invoiceRef}`, 
                '_blank', `ReceiptCash`, 
                "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-5/6 w-11/12">
      <template v-slot:title>
        <h5 class="font-medium text-sm">Consultant Payment Details</h5>
      </template>
      <template v-slot:modal-body>
        <div class="flex flex-wrap -m-3">
            <div class="w-full flex flex-wrap">
                <div class="flex-1 p-tiny">
                    <h5 class="font-medium text-base">Consultant: {{ consultant }}</h5>
                </div>
                <div class="flex-1 p-tiny">
                    <h5 class="font-medium text-base">Mode: {{ payment.mode }} </h5>
                </div>
                <div class="flex-1 p-tiny">
                    <h5 class="font-medium text-base">Reference: {{ payment.invoiceRef }}</h5>
                </div>
                <div class="flex-1 p-tiny">
                    <h5 class="font-medium text-base">Payment Date: 
                        {{ payment.trxDate | dateFormat }}</h5>
                </div>
            </div>
            <div class="w-full overflow-auto">
                <table class="table">
                    <thead class="bg-blue-500 text-sm text-white">
                        <tr>
                            <th class="p-px">Transaction Date</th>
                            <th class="p-px">Payment Date</th>
                            <th class="p-px">Patient</th>
                            <th class="p-px">IP No</th>
                            <th class="p-px">OP No</th>
                            <th class="p-px">Service</th>
                            <th class="p-px">Amount</th>
                            <th class="p-px">Paid</th>
                            <th class="p-px">Balance</th>
                            <th class="p-px">Ref</th>
                            <th class="p-px">Memo</th>
                        </tr>
                    </thead>
                    <tfoot class="text-base">
                        <tr>
                            <th class="p-tiny" colspan="4">
                                Total Amt: {{ totalAmount | numberFormat }}
                            </th>
                            <th class="p-tiny" colspan="4">
                                Total Paid: {{ totalPaid | numberFormat  }}
                            </th>
                            <th class="p-tiny" colspan="4">
                                Total Balance: {{ totalBalance | numberFormat }}
                            </th>
                        </tr>
                    </tfoot>
                    <tbody class="text-sm">
                        <tr v-for="(paymentD,idx) in paymentDetails" :key="idx">
                            <td class="p-px">{{ paymentD.billDate | dateFormat }}</td>
                            <td class="p-px">{{ paymentD.trxDate | dateFormat }}</td>
                            <td class="p-px">{{ paymentD.names }}</td>
                            <td class="p-px">{{ paymentD.ipfileno || `-` }}</td>
                            <td class="p-px">{{ paymentD.opfileno || `-` }}</td>
                            <td class="p-px">{{ paymentD.itemName }}</td>
                            <td class="p-px">{{ paymentD.amount | numberFormat }}</td>
                            <td class="p-px">{{ paymentD.paid | numberFormat }}</td>
                            <td class="p-px">{{ paymentD.balance | numberFormat }}</td>
                            <td class="p-px">{{ paymentD.receiptNo || `-` }}</td>
                            <td class="p-px">{{ paymentD.invoiceMemo || `-` }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button 
            class="btn-danger btn-sm text-xs rounded-md mr-6" 
            @click.prevent="$emit(`closeModal`)">
                <i class="fa fa-times"></i> Close</button>
        <button 
            @click.prevent="printDetails"
            class="btn-sm btn-primary text-xs rounded-md">
                <i class="fa fa-print"></i> Print</button>
      </template>
    </tail-modal>
</template>
